import { createTemplateDashboard } from 'components/reusable/template/list';
import { GenericPass } from '../genericPass';
import { useListGenericPassTemplatesQuery } from 'services/genericPasses';


export const GenericPassTemplateDashboard = createTemplateDashboard({
  TemplateRenderer: GenericPass,
  listTemplateHook: useListGenericPassTemplatesQuery,
  i18nNamespace: "genericPass"
})